// File: Componates/ParkingSection.jsx
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Modal } from "react-bootstrap";
import { InfoCircle } from "react-bootstrap-icons";
import { formatValue } from "./utils/checkoutTableUtils";

/**
 * `data.parking_detail` now arrives from the backend already carrying
 * `movements`, `segments`, and `parking_total` (computed in
 * getCheckOutDetails via calcParkingBreakdown on the server). This
 * component only renders — it no longer calls calcParkingBreakdown itself.
 */
const ParkingSection = ({ data }) => {
  const [showModal, setShowModal] = useState(false);

  const parking_detail = data.parking_detail;
  if (!parking_detail) return null;

  const movements = parking_detail.movements || [];
  const segments = parking_detail.segments || [];
  const parking_total = Number(parking_detail.parking_total || 0);

  

  return (
    <>
      <div className="col-12 col-lg-6">
        {/* Parking Summary */}
        <div className="table-responsive w-100">
          <table className="table table-bordered align-middle mb-0 h-100">
            <thead className="table-light">
              <tr>
                <th colSpan="4" className="fw-bold">
                  <div className="d-flex justify-content-between align-items-center">
                    Parking Summary
                    {movements.length > 0 && (
                      <Button
                        size="sm"
                        variant="outline-primary"
                        onClick={() => setShowModal(true)}
                      >
                        <InfoCircle className="me-2" />
                        View Breakdown
                      </Button>
                    )}
                  </div>
                </th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <th width="20%">Total Vehicles</th>
                <td width="30%">
                  {formatValue(parking_detail.total_vehicle)}
                </td>

                <th width="20%">Currently Parked</th>
                <td width="30%">
                  {formatValue(parking_detail.current_vehicle)}
                </td>
              </tr>

              <tr>
                <th>Parking Rate</th>
                <td>{formatValue(parking_detail.parking_rate, "currency")}</td>

                <th>Parking Total</th>
                <td className="fw-bold text-end">
                  {formatValue(parking_total, "currency")}
                </td>
              </tr>

              {parking_detail.remarks && (
                <tr>
                  <th>Remarks</th>
                  <td colSpan="3">{parking_detail.remarks}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Parking Movements Modal */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Parking Breakdown</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {segments.length ? (
            <div className="table-responsive">
              <table className="table table-bordered align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Period</th>
                    <th className="text-center">Vehicles Parked</th>
                    <th className="text-center">Days</th>
                    <th className="text-end">Amount</th>
                  </tr>
                </thead>

                <tbody>
                  {segments.map((s, index) => (
                    <tr key={index}>
                      <td>
                        {formatValue(s.from, "date")}
                        {" → "}
                        {formatValue(s.to, "date")}
                      </td>

                      <td className="text-center">{s.vehicles}</td>

                      <td className="text-center">{s.days}</td>

                      <td className="text-end">
                        {formatValue(s.amount, "currency")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-4 text-muted">
              No parking breakdown available.
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

ParkingSection.propTypes = {
  data: PropTypes.object,
};

export default ParkingSection;